import apiHelpers from '@/utils/api'
import { AlrContainer } from '@/models/response/AlrContainer'
import { AxiosPromise } from 'axios'
import { AloPanStatus,cleanAloPanStatus } from '@/models/alo/AloPanStatus'

export default {
  getAllPanStatus(): AxiosPromise<AlrContainer<Array<AloPanStatus>>> {    
    return apiHelpers.apiCall({ 
      url: `/webapi/PanStatus`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<Array<AloPanStatus>>
      }]
    })
  },
  getPanStatus(id:number):AxiosPromise<AlrContainer<AloPanStatus>> {
    return  apiHelpers.apiCall({ 
      url: `/webapi/PanStatus/${id}`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<AloPanStatus>
      }]
    })
  },
  savePanStatus(panStatus:AloPanStatus):AxiosPromise<AlrContainer<AloPanStatus>> {
    cleanAloPanStatus(panStatus)
    //cas particulier pour gerer que l'id 0 existe merci à celui qui a eu la bonne idée de commencer à 0!!!!
    if((panStatus.id && panStatus.id !=-1) || panStatus.id === 0) {
      return  apiHelpers.apiCall({ 
        url: `/webapi/PanStatus/${panStatus.id}`, 
        method: 'PUT',
        data: panStatus,
        transformResponse: [function (data:string) {          
          return JSON.parse(data) as AlrContainer<AloPanStatus>
        }]
      })    
    }
    else{
      return  apiHelpers.apiCall({ 
        url: `/webapi/PanStatus`, 
        method: 'POST',
        data: panStatus,
        transformResponse: [function (data:string) {          
          return JSON.parse(data) as AlrContainer<AloPanStatus>
        }]
      })    
    }
  },
  deletePanStatus(id:number):AxiosPromise<AlrContainer<AloPanStatus>>{
    return  apiHelpers.apiCall({ 
      url: `/webapi/PanStatus/${id}`, 
      method: 'DELETE',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<AloPanStatus>
      }]
    })
  }
}